// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDebit} from '../../shared/repositories';
import {readDebitTypes} from '../../shared/action-creators/debit-types';
import {updateConfirmationModalVisibility} from './confirmation-modal';

export const readPartialDebit = claimNumber =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const debit = await getDebit(claimNumber);

            if (debit.isDebitFormRequired) {

                updateConfirmationModalVisibility(true)(dispatch);

            } else {

                dispatch({
                    debit,
                    type: actions.UPDATE_TCSM_PARTIAL_DEBIT_DATA
                });

                readDebitTypes(actions.UPDATE_TCSM_PARTIAL_DEBIT_TYPE, 'P')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/read-debit.js